import { useDebug } from '@hooks'
import { GizmoHelper, GizmoViewport } from '@react-three/drei'

import { useHelpersControls, usePostProcessingControls } from '@utils'
import { PerfMonitor } from 'r3f-monitor'

export function Helpers() {
  const { axes, gizmo } = useHelpersControls()
  const { enabled: postProcessingEnabled } = usePostProcessingControls()

  const debug = useDebug()

  return (
    <>
      {axes && <axesHelper args={[20]} position-y={0.001} />}

      {gizmo && (
        <GizmoHelper renderPriority={postProcessingEnabled ? 3 : 2}>
          <GizmoViewport labelColor="white" />
        </GizmoHelper>
      )}

      {debug && <PerfMonitor showGraph={false} position="top-left" displayType="classic" />}
    </>
  )
}
